export const coins = (value: number) => new Intl.NumberFormat('tr-TR').format(value);
export const marketDate = (value: string) =>
  new Intl.DateTimeFormat('tr-TR', {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(new Date(value));
